import { twMerge } from 'tailwind-merge';

import SeekerGraphic from '../../assets/seeker-graphic.png';
import SeekerImageBg from '../../assets/seeker-image-bg.jpg';
import { LayoutWithBgGradient } from '../LayoutWithBgGradient';
import { LogoFull } from '../LogoFull';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

export function TwoPanelsWithSeekerHero(props: Props) {
  return (
    <LayoutWithBgGradient className={props.className}>
      <div
        className={twMerge(
          'grid',
          'grid-cols-1',
          'lg:grid-cols-2',
          'h-[100dvh]',
          'w-full',
        )}
      >
        <div
          className={twMerge(
            'bg-[#A6BEC9]',
            'bg-blend-overlay',
            'bg-contain',
            'bg-top',
            'hidden',
            'lg:grid',
            'overflow-hidden',
            'place-items-center',
            'relative',
          )}
        >
          <img
            className="absolute bg-blend-multiply h-full"
            src={SeekerImageBg}
            alt=""
            aria-hidden="true"
          />
          <img
            className="absolute max-w-[1000px] translate-y-[260px]"
            src={SeekerGraphic}
            alt=""
            aria-hidden="true"
          />
          <div className="flex flex-col items-center relative translate-y-[-200px] gap-4">
            <LogoFull className="h-[24px]" type="dark" />
            <div className="text-center justify-start text-black text-6xl font-normal font-inter leading-[55.44px]">
              Publishing Portal
            </div>
          </div>
        </div>
        <div className="overflow-y-auto">{props.children}</div>
      </div>
    </LayoutWithBgGradient>
  );
}
